/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMapSearch = createReactComponent("map-search", "IconMapSearch", [
  ["path", { d: "M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v7.5", key: "svg-0" }],
  ["path", { d: "M9 4v13", key: "svg-1" }],
  ["path", { d: "M15 7v5", key: "svg-2" }],
  ["path", { d: "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-3" }],
  ["path", { d: "M20.2 20.2l1.8 1.8", key: "svg-4" }]
]);

export { IconMapSearch as default };
//# sourceMappingURL=IconMapSearch.js.map
